import { useMemo } from 'react';
import { useFeatureIsOn } from 'src/common/growthbook';
import { isTaskBreakdownSupported } from 'src/features/room/helpers/is-task-breakdown-supported';
export const useIsTaskBreakdownSupportedAndShowPremiumButton = (roomCode: string) => {
  const isFeatureOn = useFeatureIsOn('add-go-premium-button');
  return useMemo(() => isFeatureOn && isTaskBreakdownSupported(roomCode), [roomCode, isFeatureOn]);
};